import { IDocComplete } from "@/types/summary";
import { formatRecordTime } from "@/utils/formatter";
import summarySrcStore from "@/store/summarySrc.store";
import SpeakerAvatar from "@/pages/Voice/SpearkerAvatar";
import { getSpeakerAvatarInfo } from "@/utils/newAvatar";
import {
  PLAYING_DOC_ITEM_CLASSNAME,
  SRC_CONTENT_CLASSNAME,
} from "@/constants/record";
import avPlayerStore from "@/store/avPlayer.store";
import { useEffect, useRef } from "react";
import AVPlayerHelper from "@/bussiness/AVPlayerHelper";
export interface IDocItemProps {
  item: IDocComplete["pg"][0];
  avatarSrc: string;
  isPlaying: boolean;
}

const DocItem: React.FC<IDocItemProps> = ({ item, avatarSrc, isPlaying }) => {
  const playingSi = avPlayerStore((state) => state.playingSi);
  const detailInfo = summarySrcStore((state) => state.detailInfo);
  const clickCount = useRef(0);

  useEffect(() => {
    if (!isPlaying) {
      clickCount.current = 0;
    }
  }, [isPlaying]);

  const audioJumpTo = (time: number) => {
    const _time = [0, time / 1000, detailInfo!.duration || Infinity].sort(
      (a, b) => a - b
    )[1];
    avPlayerStore.getState().audioPlayerIns?.setCurrentTime(_time);
    avPlayerStore.getState().videoPlayerIns?.setCurrentTime(_time);
    AVPlayerHelper.textJumpCb();
  };

  const toggle = () => {
    avPlayerStore.getState().audioPlayerIns?.toggle();
    avPlayerStore.getState().videoPlayerIns?.toggle();
  };

  const handleClick = (time: number) => {
    if (clickCount.current === 0) {
      audioJumpTo(time);
    } else if (isPlaying) {
      toggle();
    }
    clickCount.current++;
  };

  const speakerAvatarInfo = getSpeakerAvatarInfo(item.headImage);
  const formatSpeakerName = item.speakerName?.[0] || "发言人";

  return (
    <div
      className={`mb-6 ${isPlaying ? PLAYING_DOC_ITEM_CLASSNAME : ""}`}
      data-p-id={item.pi}
    >
      <div
        id="content"
        className="flex items-center text-#A1A7B2 text-3 pb-2.5 relative"
      >
        {item.headImage ? (
          <SpeakerAvatar
            speakerName={item.speakerName[0]}
            avatarIndex={speakerAvatarInfo.avatarIndex}
            useDefaultAvatarIcon={item.useDefaultIcon}
            className="h-4 size-4 mr-1"
            fontSize="0.5rem"
          />
        ) : (
          <img src={avatarSrc} className="h-6 mr-1" />
        )}
        <div className="mr-2 py-0.875 px-1 rounded-1">{formatSpeakerName}</div>

        {formatRecordTime((item.sc[0]?.bt || 0) / 1000) || "00:00"}
      </div>

      <div
        onClick={() => handleClick(item.sc[0].bt)}
        className={`${SRC_CONTENT_CLASSNAME} ${
          isPlaying ? " bg-mx-primary b-transparent" : "bg-white b-white"
        }  px-4 py-3 rounded-4 rounded-lt-0 b-1 b-solid text-3.5 text-#30343C text-justify`}
      >
        {item.sc.map((sentence) => (
          <span
            key={sentence.si}
            className={`select-text  ${
              isPlaying
                ? playingSi === sentence.si
                  ? "text-#fff"
                  : "text-#ffffff80"
                : ""
            } ${(item.mark || sentence.mark) && "bg-#B2F5D4"} `}
            onClick={(e) => {
              e.stopPropagation();
              handleClick(sentence.bt);
            }}
          >
            {sentence.tc}
          </span>
        ))}
      </div>
    </div>
  );
};

export default DocItem;
